export default __webpack_public_path__ + "static/media/graphic-2.7389ff28.png";